<aside class="aside aside-fixed">
    <div class="aside-inner">
        <div class="aside-header">
            <a [routerLink]="['./']" class="aside-logo">
                <img src="/assets/images/logo.svg" alt="" />
            </a>
        </div>
        <div class="aside-body">
            <ul class="nav nav-aside">
                <div class="menu_aside">
                    <div>
                        <li
                            class="nav-item"
                            routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: true }"
                            (click)="hideSideBar()"
                        >
                            <a
                                [routerLink]="['/dashboard']"
                                class="nav-link"
                                (click)="hideSideBar()"
                            >
                                <img
                                    src="/assets/images/dashboard-icons/home-icon.svg"
                                    alt=""
                                />
                                <span i18n="@@welcomeHeader">{{
                                    navigation.dashboardTitle
                                }}</span>
                            </a>
                        </li>
                        <hr style="border-color: #2a3238" />
                        <div class="nav-item_title">
                            <li
                                class="nav-label nav-link"
                                [ngClass]="isTitleOpen ? 'active' : ''"
                                (click)="hideSideBar()"
                                (click)="isTitleOpen = !isTitleOpen"
                            >
                                <div
                                    class="d-flex align-items-center justify-content-start"
                                    (click)="hideSideBar()"
                                >
                                    <img
                                        src="/assets/images/dashboard-icons/folder.svg"
                                        alt=""
                                    />

                                    <div
                                        class="d-flex flex-row flex-wrap align-items-center justify-content-between w-100 gap-5"
                                    >
                                        <div>
                                            <span i18n="@@welcomeText">{{
                                                navigation.sidebarTitle
                                            }}</span>
                                        </div>
                                        <div></div>
                                        <div
                                            class="d-flex align-self-center justify-content-end"
                                        >
                                            <img
                                                src="/assets/images/dashboard-icons/chevron-up.svg"
                                                alt=""
                                                *ngIf="isTitleOpen"
                                            />
                                            <img
                                                src="/assets/images/dashboard-icons/chevron-up.svg"
                                                alt=""
                                                *ngIf="!isTitleOpen"
                                                class="rotate-180"
                                            />
                                        </div>
                                    </div>
                                    <!-- <div class="plusCircle" data-bs-toggle="modal" data-bs-target="#addnewstudiomodal"><span
                  class="title_text">+</span></div> -->
                                </div>
                            </li>
                            <div class="" *ngIf="isTitleOpen">
                                <div *ngIf="dropDown.length != 0">
                                    <div
                                        *ngFor="let d of dropDown"
                                        [ngClass]="{
                                            'dropdown-open': d.data?.status == 1
                                        }"
                                    >
                                        <p
                                            class="cursor px-4"
                                            [ngClass]="
                                                d.data?.status == 1
                                                    ? 'nav_label_text'
                                                    : ''
                                            "
                                            (click)="openDropdown(d.data?.id)"
                                        >
                                            {{ d.data?.title }}
                                        </p>
                                        <ul
                                            class="nav nav-aside px-4"
                                            *ngIf="d.data?.status == 1"
                                        >
                                            <li
                                                class="nav-item"
                                                [routerLink]="[
                                                    '/dashboard/title'
                                                ]"
                                                routerLinkActive="active"
                                                [routerLinkActiveOptions]="{
                                                    exact: true
                                                }"
                                                (click)="hideSideBar()"
                                            >
                                                <a
                                                    class="nav-link-dropdown"
                                                    (click)="hideSideBar()"
                                                    title="{{
                                                        navigation.files
                                                    }}"
                                                >
                                                    <img
                                                        src="/assets/images/dashboard-icons/dot-dark.svg"
                                                        alt=""
                                                        class="icon dark-icon"
                                                    />
                                                    <img
                                                        src="/assets/images/dashboard-icons/dot.svg"
                                                        alt=""
                                                        class="icon color-icon"
                                                    />
                                                    <span>{{
                                                        navigation.files
                                                    }}</span>
                                                </a>
                                            </li>
                                            <li
                                                class="nav-item"
                                                [routerLink]="[
                                                    '/dashboard/metadata'
                                                ]"
                                                routerLinkActive="active"
                                                [routerLinkActiveOptions]="{
                                                    exact: true
                                                }"
                                                (click)="hideSideBar()"
                                            >
                                                <a
                                                    class="nav-link-dropdown"
                                                    (click)="hideSideBar()"
                                                    title="{{
                                                        navigation.metadata
                                                    }}"
                                                >
                                                    <img
                                                        src="/assets/images/dashboard-icons/dot-dark.svg"
                                                        alt=""
                                                        class="icon dark-icon"
                                                    />
                                                    <img
                                                        src="/assets/images/dashboard-icons/dot.svg"
                                                        alt=""
                                                        class="icon color-icon"
                                                    />
                                                    <span>{{
                                                        navigation.metadata
                                                    }}</span>
                                                </a>
                                            </li>
                                            <!-- <li class="nav-item" [routerLink]="['/dashboard/imdb']" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" (click)="hideSideBar()">
              <a class="nav-link" (click)="hideSideBar()" title="{{navigation.IMDB}}">
                <img src="/assets/images/icon-8.png" alt="">
                <span>{{navigation.IMDB}}</span>
              </a>
            </li> -->
                                            <li
                                                class="nav-item"
                                                routerLinkActive="active"
                                                *ngIf="
                                                    d.role == 'Administrator' ||
                                                    d.role == 'Admin'
                                                "
                                                [routerLinkActiveOptions]="{
                                                    exact: true
                                                }"
                                                (click)="hideSideBar()"
                                            >
                                                <a
                                                    [routerLink]="[
                                                        '/dashboard/member'
                                                    ]"
                                                    class="nav-link-dropdown"
                                                    (click)="hideSideBar()"
                                                    title="{{
                                                        navigation.Members
                                                    }}"
                                                >
                                                    <img
                                                        src="/assets/images/dashboard-icons/dot-dark.svg"
                                                        alt=""
                                                        class="icon dark-icon"
                                                    />
                                                    <img
                                                        src="/assets/images/dashboard-icons/dot.svg"
                                                        alt=""
                                                        class="icon color-icon"
                                                    />
                                                    <span>{{
                                                        navigation.Members
                                                    }}</span>
                                                </a>
                                            </li>

                                            <li
                                                class="nav-item"
                                                routerLinkActive="active"
                                                *ngIf="
                                                    d.role == 'Administrator' ||
                                                    d.role == 'Admin'
                                                "
                                                [routerLinkActiveOptions]="{
                                                    exact: true
                                                }"
                                                (click)="hideSideBar()"
                                            >
                                                <a
                                                    [routerLink]="[
                                                        '/dashboard/order-history'
                                                    ]"
                                                    class="nav-link-dropdown"
                                                    (click)="hideSideBar()"
                                                    title="{{
                                                        navigation.orderHistory
                                                    }}"
                                                >
                                                    <img
                                                        src="/assets/images/dashboard-icons/dot-dark.svg"
                                                        alt=""
                                                        class="icon dark-icon"
                                                    />

                                                    <img
                                                        src="/assets/images/dashboard-icons/dot.svg"
                                                        alt=""
                                                        class="icon color-icon"
                                                    />
                                                    <span>{{
                                                        navigation.orderHistory
                                                    }}</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <hr style="border-color: #2a3238" />
                    </div>
                    <div>
                        <li
                            class="nav-item"
                            routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: true }"
                            (click)="hideSideBar()"
                        >
                            <a
                                class="nav-link"
                                routerLink="/dashboard/billing-details"
                                (click)="hideSideBar()"
                                title="{{ navigation.billingDetails }}"
                            >
                                <img
                                    src="/assets/images/dashboard-icons/billing-icon.svg"
                                    alt=""
                                />
                                <span>{{ navigation.billingDetails }}</span>
                            </a>
                        </li>

                        <div
                            [ngClass]="
                                isAccountSettingOpen ? 'dropdown-open' : ''
                            "
                        >
                            <li
                                class="nav-item cursor"
                                [ngClass]="isAccountSettingOpen ? 'active' : ''"
                                (click)="hideSideBar()"
                                (click)="
                                    isAccountSettingOpen = !isAccountSettingOpen
                                "
                            >
                                <a
                                    class="nav-link"
                                    (click)="hideSideBar()"
                                    title="{{ navigation.accountSettings }}"
                                >
                                    <img
                                        src="/assets/images/dashboard-icons/settings-icon.svg"
                                        alt=""
                                    />
                                    <span>{{
                                        navigation.accountSettings
                                    }}</span>
                                </a>
                            </li>
                            <div
                                class="my_title_nav"
                                *ngIf="isAccountSettingOpen"
                            >
                                <ul class="nav nav-aside">
                                    <li
                                        class="nav-item"
                                        [routerLink]="[
                                            '/dashboard/profile-settings'
                                        ]"
                                        routerLinkActive="active"
                                        [routerLinkActiveOptions]="{
                                            exact: true
                                        }"
                                        (click)="hideSideBar()"
                                    >
                                        <a
                                            class="nav-link-dropdown"
                                            (click)="hideSideBar()"
                                            title="{{
                                                navigation.profileSetting
                                            }}"
                                        >
                                            <img
                                                src="/assets/images/dashboard-icons/dot-dark.svg"
                                                alt=""
                                                class="icon dark-icon"
                                            />
                                            <img
                                                src="/assets/images/dashboard-icons/dot.svg"
                                                alt=""
                                                class="icon color-icon"
                                            />
                                            <span>{{
                                                navigation.profileSetting
                                            }}</span>
                                        </a>
                                    </li>
                                    <li
                                        class="nav-item"
                                        routerLinkActive="active"
                                        [routerLinkActiveOptions]="{
                                            exact: true
                                        }"
                                        (click)="hideSideBar()"
                                    >
                                        <a
                                            [routerLink]="[
                                                '/dashboard/account-details'
                                            ]"
                                            class="nav-link-dropdown"
                                            (click)="hideSideBar()"
                                            title="{{
                                                navigation.accountDetails
                                            }}"
                                        >
                                            <img
                                                src="/assets/images/dashboard-icons/dot-dark.svg"
                                                alt=""
                                                class="icon dark-icon"
                                            />
                                            <img
                                                src="/assets/images/dashboard-icons/dot.svg"
                                                alt=""
                                                class="icon color-icon"
                                            />
                                            <span>{{
                                                navigation.accountDetails
                                            }}</span>
                                        </a>
                                    </li>
                                    <li
                                        class="nav-item"
                                        routerLinkActive="active"
                                        [routerLinkActiveOptions]="{
                                            exact: true
                                        }"
                                        (click)="hideSideBar()"
                                    >
                                        <a
                                            [routerLink]="[
                                                '/dashboard/cloud-storage'
                                            ]"
                                            class="nav-link-dropdown"
                                            (click)="hideSideBar()"
                                            title="{{
                                                navigation.cloudStorage
                                            }}"
                                        >
                                            <img
                                                src="/assets/images/dashboard-icons/dot-dark.svg"
                                                alt=""
                                                class="icon dark-icon"
                                            />
                                            <img
                                                src="/assets/images/dashboard-icons/dot.svg"
                                                alt=""
                                                class="icon color-icon"
                                            />
                                            <span>{{
                                                navigation.cloudStorage
                                            }}</span>
                                        </a>
                                    </li>
                                    <li
                                        class="nav-item"
                                        routerLinkActive="active"
                                        [routerLinkActiveOptions]="{
                                            exact: true
                                        }"
                                        (click)="hideSideBar()"
                                    >
                                        <a
                                            [routerLink]="[
                                                '/dashboard/manage-title'
                                            ]"
                                            class="nav-link-dropdown"
                                            (click)="hideSideBar()"
                                            title="{{ navigation.manageTitle }}"
                                        >
                                            <img
                                                src="/assets/images/dashboard-icons/dot-dark.svg"
                                                alt=""
                                                class="icon dark-icon"
                                            />
                                            <img
                                                src="/assets/images/dashboard-icons/dot.svg"
                                                alt=""
                                                class="icon color-icon"
                                            />
                                            <span>{{
                                                navigation.manageTitle
                                            }}</span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <!-- <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" -->
                        <!-- (click)="hideSideBar()"> -->
                        <!-- <a  class="nav-link" (click)="hideSideBar()" (click)="logout()">
          <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg>
          <span>Logout</span>
        </a> -->
                        <!-- <a class="nav-link" (click)="hideSideBar()" data-bs-toggle="modal" data-bs-target="#logoutmodal"
            title="{{navigation.logout}}">
            <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none"
              stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
              <polyline points="16 17 21 12 16 7"></polyline>
              <line x1="21" y1="12" x2="9" y2="12"></line>
            </svg>
            <span>{{navigation.logout}}</span>
          </a>
        </li> -->
                        <div class="header_right_right">
                            <a
                                class="nav-link"
                                (click)="hideSideBar()"
                                data-bs-toggle="modal"
                                data-bs-target="#logoutmodal"
                            >
                                <div class="mvp_account_header">
                                    <div class="mvp_account_header_inner">
                                        <div class="mvp_account_icon">
                                            <span>
                                                {{ shortname | uppercase }}
                                            </span>
                                            <!-- <span *ngIf="imageUrl" [ngClass]="dynamicColor" (click)="this.isProfile=!this.isProfile">
              <img [src]="imageUrl" alt="">
            </span> -->
                                            <img
                                                src="/assets/images/dashboard-icons/online.svg"
                                                class="online-indicator"
                                            />
                                        </div>
                                        <div class="mvp_account_body">
                                            <p>
                                                <span
                                                    class="mvp_account_body_title"
                                                    >{{
                                                        name || 'John Deo'
                                                    }}</span
                                                >
                                                {{ dashbaordData.admin }}
                                            </p>
                                        </div>
                                    </div>
                                    <!-- <div class="mvp_account_icon">
            <span *ngIf="imageUrl==''">
             {{shortName}}
            </span>
            <span *ngIf="imageUrl">
              <img [src]="imageUrl" alt="not found" (error)="handleImageError()">
             </span>
          </div> -->
                                    <div>
                                        <img
                                            src="/assets/images/dashboard-icons/chevron-selector-vertical.svg"
                                        />
                                    </div>
                                </div>
                            </a>
                        </div>
                        <select
                            id="languageSelect"
                            name="language"
                            class="select_lang"
                            [value]="language"
                            (change)="changeLanguage($event)"
                        >
                            <option value="en">English</option>
                            <option value="hi">Hindi</option>
                            <option value="zh-CN">Mandarin</option>
                            <option value="ko">Korean</option>
                            <option value="es">Spanish</option>
                            <option value="fr">French</option>
                            <option value="ja">Japanese</option>
                            <option value="pt">Portuguese</option>
                            <option value="it">Italian</option>
                        </select>
                    </div>
                </div>
            </ul>
        </div>
    </div>
</aside>

<div
    class="modal fade"
    id="addnewstudiomodal"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="staticBackdropLabel"
    aria-hidden="true"
>
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header studeio_modal_header">
                <div class="studeio_modal_inner_header">
                    <div class="studeio_modal_image">
                        <img
                            src="/assets/images/dashboard-icons/video-icon.svg"
                            alt=""
                        />
                    </div>
                    <div>
                        <h1 class="modal-title" id="staticBackdropLabel">
                            {{ navigation.addTitle }}
                        </h1>

                        <h6 class="modal-subtitle">
                            {{ navigation.addSubTitle }}
                        </h6>
                    </div>
                </div>
                <img
                    src="/assets/images/cancel.png"
                    class="cursor_pointer"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    alt=""
                />
            </div>
            <hr style="border-color: #2a3238" />

            <div class="modal-body studio_modal_body">
                <form [formGroup]="titleForm">
                    <div class="pop_group">
                        <p class="pop_label">{{ navigation.titleName }}</p>
                        <input
                            type="text"
                            class="form-control add_form_control"
                            formControlName="title"
                            [placeholder]="navigation.titleNamePlaceholder"
                        />
                    </div>
                </form>
                <!-- <p class="initiate_content">{{navigation.titleContent}}</p> -->
            </div>
            <div class="modal-footer modal_footer">
                <button
                    type="button"
                    class="btn studio_back_btn"
                    #modalCloseButton
                    data-bs-dismiss="modal"
                >
                    {{ navigation.back }}
                </button>

                <button
                    type="button"
                    class="btn studio_create_btn"
                    [disabled]="titleForm.invalid || clicked"
                    (click)="SaveTitle()"
                >
                    {{ navigation.createTitle }}
                </button>
            </div>
        </div>
    </div>
</div>

<!-- logout-start -->
<div
    class="modal fade"
    id="logoutmodal"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="staticBackdropLabel"
    aria-hidden="true"
>
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body logout_modal_body">
                <div class="logout_modal_body_inner">
                    <img
                        src="/assets/images/cancel.png"
                        class="logout_cancel"
                        alt=""
                        data-bs-dismiss="modal"
                        aria-label="Close"
                    />
                    <p class="logout_heading">
                        {{ navigation.logoutConfirmation }}
                    </p>
                    <p class="logout_sub_heading">
                        {{ navigation.logoutcontent }}
                    </p>
                </div>
            </div>
            <div class="modal-footer logout_modal_footer">
                <button
                    type="button"
                    class="btn logout_modal_cancel_btn"
                    #modalCloseButton1
                    data-bs-dismiss="modal"
                >
                    {{ navigation.cancel }}
                </button>
                <button
                    type="button"
                    class="btn logout_modal_btn"
                    (click)="logout()"
                >
                    {{ navigation.logout }}
                </button>
            </div>
        </div>
    </div>
</div>
<!-- logout-end -->
<app-pop-up></app-pop-up>
